import * as math from 'mathjs';

const performMonteCarloOptimization3 = ({
    numSimulations,
    selectedAssets,
    covarianceMatrix,
    returnsArray,
    alpha, // Weighting factor for return in the objective function
}) => {
    const numAssets = selectedAssets?.length || 0;

    if (!selectedAssets || selectedAssets.length < 2) {
        console.error("You need to select at least two assets.");
        return "No feasible solution found.";
    }

    let bestObjectiveValue = -Infinity;
    let bestWeights = null;

    for (let i = 0; i < numSimulations; i++) {
        // Generate random weights and normalize them
        let weights = Array.from({ length: numAssets }, () => Math.random());
        const sumWeights = weights.reduce((a, b) => a + b, 0);
        weights = weights.map(weight => weight / sumWeights);

        // Calculate the portfolio's return and ESG score
        const returnPart = math.dot(weights, returnsArray);
        const ESGScores = selectedAssets.map(asset => 
            asset.ESGworkforce + asset.ESGstrategy // Adjust based on your ESG scoring
        );
        const ESGPart = math.dot(weights, ESGScores);

        // Calculate the weighted objective
        const objectiveValue = alpha * returnPart + (1 - alpha) * ESGPart;

        // Check if this is the best (maximum) objective value so far
        if (objectiveValue > bestObjectiveValue) {
            bestObjectiveValue = objectiveValue;
            bestWeights = weights;
        }
    }

    if (bestWeights) {
        console.log("Best Objective Value:", bestObjectiveValue);
        return bestWeights;
    } else {
        alert("No feasible solution found.");
        return "No feasible solution found.";
    }
};

export default performMonteCarloOptimization3;
